
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|2350|2888|9098)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
